import { render, staticRenderFns } from "./GroupMemberInfo.vue?vue&type=template&id=ef6c1e14&"
import script from "./GroupMemberInfo.vue?vue&type=script&lang=js&"
export * from "./GroupMemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupMemberInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports